<template>
  <Modal name="CHANGE_APPOINTMENT_KEY_LOCATION_MODAL" :title="$t('appointment.adminActions.changeKeyLocation.action')">
    <template v-slot:body>
      <v-form v-model="valid" ref="appointmentFormChangeKeyLocation">
        <v-autocomplete
          v-model="selectedKeyLocation"
          @change="handleChange"
          :label="$t('appointment.adminActions.changeKeyLocation.selectKeyLocation')"
          :items="keyLocations"
          :rules="rules"
          item-value="value"
          item-text="name"
          outlined
        />

        <div v-if="specificAddress">
          <h5>{{ $t('appointment.adminActions.changeKeyLocation.newKeyAddress') }}</h5>
          <p class="mb-8">{{ specificAddress }}</p>
        </div>

        <div v-if="showRealtySelection">
          <v-autocomplete
            :items="appointment.realties"
            :item-text="(realty) => `#${realty.code} - ${realty.address}`"
            item-value="id"
            :label="$t('appointment.adminActions.changeKeyLocation.selectRealty')"
            v-model="specificId"
            :rules="rules"
            outlined
          />
        </div>

        <span v-if="showBranchSelection">
          <AdminBranchSelect
            v-model="selectedBranch"
            :realEstateId="realEstateId"
            :label="$t('appointment.adminActions.changeKeyLocation.selectBranch')"
            :showOutterLabel="false"
            :rules="rules"
            :dense="false"
          />
        </span>

        <div v-if="showAddressField">
          <AddressSearch
            :rules="rules"
            @address="setAddress"
            :focus="true"
            ref="addressSearch"
          />
        </div>

        <div class="d-flex justify-end">
          <v-btn
            @click="validate"
            :loading="isChangingKeyLocation"
            elevation="0"
            color="primary"
            large
            dark
          >
            {{ $t('appointment.adminActions.changeKeyLocation.action') }}
          </v-btn>
          </div>
      </v-form>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/app/Modal'
import AddressSearch from '@/components/app/AddressSearch'
import { required } from '@/util/errorHandling'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AdminBranchSelect from '@/components/branch/AdminBranchSelect'
export default {
  name: 'AppointmentFormChangeKeyLocation',
  components: {
    Modal,
    AddressSearch,
    AdminBranchSelect
  },
  data() {
    return {
      rules: [
        required
      ],
      valid: false,
      selectedKeyLocation: null,
      keyLocations: [
        {
          name: this.$t('appointment.keyLocation.REAL_ESTATE'),
          value: 'REAL_ESTATE',
        },
        {
          name: this.$t('appointment.keyLocation.REALTY'),
          value: 'REALTY',
        },
        {
          name: this.$t('appointment.keyLocation.OTHER'),
          value: 'OTHER',
        },
      ],
      selectedBranch: null,
      address: null,
      specificId: null,
      specificAddress: null,

      isChangingKeyLocation: false,
    }
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading', 'branches']),

    showAddressField() {
      return this.selectedKeyLocation == 'OTHER'
    },

    showRealtySelection() {
      if (this.selectedKeyLocation == 'REALTY') {
        if (this.appointment.realties && this.appointment.realties.length == 1) {
          this.specificAddress = this.appointment.realties[0].address
          this.specificId = this.appointment.realties[0].id
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },

    showBranchSelection() {
      if (this.selectedKeyLocation == 'REAL_ESTATE') {
        return true
      } else {
        return false
      }
    },

    realEstateId() {
      return this.appointment?.real_estate?.id ?? null
    },
  },
  watch: {
    selectedBranch(value) {
      if (!value) return

      this.specificAddress = this.selectedBranch?.address
      this.specificId = this.selectedBranch?.id
    },
  },
  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['changeAppointmentKeyLocation', 'fetchBranchesAsAdmin', 'showSuccessMessage']),

    setAddress({address}) {
      this.address = address
    },

    handleChange() {
      this.selectedBranch = null
      this.specificAddress = null
    },

    resetFields() {
      this.specificId = null
      this.specificAddress = null
      this.address = null
    },

    validate() {
      if (this.$refs.appointmentFormChangeKeyLocation.validate()) {
        this.isChangingKeyLocation = true

        const body = {
          appointment_id: this.appointment.id,
          key_location_options: {
            key_location: this.selectedKeyLocation,
            address: this.address,
            id: this.specificId,
          }
        }

        this.changeAppointmentKeyLocation(body)
          .then(() => {
            if (this.$parent?.refreshMap) this.$parent?.refreshMap()
            if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
          })
          .then(() => this.showSuccessMessage(this.$t('appointment.messages.updated')))
          .then(() => this.closeAllModals())
          .then(() => this.resetFields())
          .finally(() => this.isChangingKeyLocation = false)
      }
    },
  }
}
</script>
